module.exports = __webpack_public_path__ + "static/img/6.67b2235.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/6.gif
// module id = 4rbc
// module chunks = 1